export default __webpack_public_path__ + "static/collage-842248f327f2942262450977495280b8.png";